import { useEffect, useState } from 'react'
import { BookingPage } from './pages/BookingPage'
import { HomePage } from './pages/HomePage'
import { MyBookingsPage } from './pages/MyBookingsPage'
import { initTelegram, isTelegram, startParam } from '@/lib/telegram'

/** Клуб при запуске: ?slug= из web_app-URL, затем start_param диплинка. */
function initialSlug(): string | null {
  const q = new URLSearchParams(window.location.search).get('slug')
  if (q && q.trim()) return q.trim()
  return startParam()
}

type Tab = 'book' | 'mine'

export function App(): React.JSX.Element {
  const [slug, setSlug] = useState<string | null>(() => initialSlug())
  const [tab, setTab] = useState<Tab>('book')
  const [notTelegram, setNotTelegram] = useState(false)

  useEffect(() => {
    initTelegram()
    setNotTelegram(!isTelegram())
  }, [])

  // Каталог клубов (если открыли без конкретного клуба).
  if (!slug) {
    return (
      <HomePage
        notTelegram={notTelegram}
        onPick={(s) => {
          setTab('book')
          setSlug(s)
        }}
      />
    )
  }

  return (
    <>
      {tab === 'book' ? (
        <BookingPage slug={slug} notTelegram={notTelegram} onGoMyBookings={() => setTab('mine')} />
      ) : (
        <MyBookingsPage slug={slug} onBook={() => setTab('book')} />
      )}

      <nav className="tabbar">
        <button className={tab === 'book' ? 'on' : ''} onClick={() => setTab('book')}>
          🎱 Бронь
        </button>
        <button className={tab === 'mine' ? 'on' : ''} onClick={() => setTab('mine')}>
          📋 Мои брони
        </button>
      </nav>
    </>
  )
}
